import { HarnessAgentBoard } from "./HarnessAgentBoard";
import { HarnessAskStep } from "./HarnessAskStep";
import { HarnessRailItem } from "./harnessRailItems";
import { HarnessThoughts } from "./HarnessThoughts";
import {
  HarnessToolCallRun,
  HarnessToolConfirmationCall,
} from "./HarnessToolCalls";

/** One outline item, whatever its kind. `live` marks the rail's single live
 *  row — the tail of the open segment while the turn streams. */
export function HarnessRailItemView({
  item,
  live,
  depth = 0,
}: {
  item: HarnessRailItem;
  live: boolean;
  depth?: number;
}) {
  switch (item.kind) {
    case "thoughts":
      return <HarnessThoughts messages={item.messages} live={live} />;
    case "confirmation":
      return (
        <HarnessToolConfirmationCall
          itemKey={item.key}
          message={item.item.message}
          toolCall={item.item.call}
        />
      );
    case "tool-run":
      return (
        <HarnessToolCallRun
          itemKey={item.key}
          toolName={item.toolName}
          entries={item.entries}
          calls={item.calls}
          live={live}
        />
      );
    case "agents":
      return (
        <HarnessAgentBoard agents={item.agents} live={live} depth={depth} />
      );
    case "ask":
      return (
        <HarnessAskStep questions={item.questions} answers={item.answers} />
      );
  }
}
